module.exports = __webpack_public_path__ + "img/dashboard.13a8bbf1.svg";